/**
 * Created by fers on 05.02.16.
 */
/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import * as Tool from '../fw/Tool';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonAdd.title', 'defaultMessage': 'Adding Application Addon'},
});

interface ChannelAddonAddStep2Props {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ChannelAddonAddStep2 extends React.Component<ChannelAddonAddStep2Props> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channelAddons';

    constructor(props) {
        super(props);
    }

    render() {
        let type = types[this.typeName];
        let addonDefType = types['addonDefs'];

        const {channel} = this.props.user.organisation;
        let {addonDef} = this.props.user;

        let tagsTag = null;
        let columnMapping = Tool.getMappingForColumn('state', addonDefType.fields());
        let tags = Tool.getDataForColumn('state', addonDefType.fields(), addonDef);
        if (tags) {
            if (!('hide' in columnMapping['values'][tags]) && !columnMapping['values'][tags].hide) {
                let style = {};
                if (columnMapping['values'][tags].color) {
                    style['backgroundColor'] = columnMapping['values'][tags].color;
                }
                tagsTag = (
                    <span className="badge" style={style}>{Tool.tranformDataForView(addonDefType.entity(), columnMapping, this.props.intl.formatMessage, tags, true)}</span>);
            }
        }

        let fields = {
            'name': {},
            'sourceDef': {
                values: this.props.user.organisation.channel.channelDef.sourceDefs.edges.map(({node}) => node),
                display: (item) => {
                    return item['name'];
                },
            },
        };

        if (addonDef && addonDef.allowConnectedChannelSelection) {
            fields['connectedChannel'] = {
                values: this.props.user.organisation.channels.edges.map(({node}) => node),
                display: (item) => {
                    if (item['name']) {
                        return item['name'] + " / " + item['channelDef']['name'];
                    } else {
                        return item['channelDef']['name'];
                    }
                },
            };
        }


        return (
            <AppPanel breadcrumbParams={[
                {type: addonDefType, data: addonDef},
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <div className="flex-row ChannelHeader">
                    <div className="flex flex-row">
                        <div className="flex-nogrow flex-column">
                            <span className="flex"></span>
                            <ChannelIcon channelDef={addonDef.channelDef ? addonDef.channelDef : {icon: 'dativery'}} className="channelViewMainIcon" size={128}/>
                            <span className="flex"></span>
                        </div>
                        <div className="flex flex-column">
                            <span className="flex"></span>
                            <h2> {addonDef.name} {tagsTag}</h2>

                            <span className="flex"></span>
                        </div>
                    </div>
                </div>

                <Editor
                    columns={fields}
                    extraConfig={[{
                        type: 'RANGE_ADD',
                        parentName: 'channel',
                        parentID: channel.id,
                        connectionName: 'channelAddons',
                        edgeName: 'edge',
                        rangeBehaviors: {
                            '': 'append',
                        },
                    }]}
                    fatQuery={Relay.QL `fragment on CreateChannelAddonPayload @relay(pattern: true) {
                        edge {
                            node {
                                id,
                            }
                        },
                        channel {
                            channelAddons(first: 100) {
                                edges {
                                    node {
                                        id
                                    }
                                }
                            }
                        }
                    }`}
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createChannelAddon }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={{
                        ...channel,
                        addonDef_id: addonDef.realId
                    }}
                    redirectToList
                    urlMapping={urlMapping}
                />

            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonAddStep2), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.addonDef;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        addonDefId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channels(first: 100, deleted: false) {
                        edges {
                            node {
                                id,
                                name,
                                channelDef {
                                    id,
                                    name,
                                    type,
                                }
                            }
                        }
                    }
                    channel(id: $channelId) {
                        id,
                        realId,
                        name,
                        organisation_id,
                        channelDef_id,
                        channelDef {
                            id,
                            name,
                            sourceDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        name,
                                        channelDef_id,
                                    }
                                }
                            }
                        }
                    }
                },
                addonDef(id: $addonDefId) {
                    id,
                    realId,
                    name,
                    description,
                    state,
                    allowConnectedChannelSelection,
                    channelDef {
                        id,
                        name,
                        icon
                    }
                }
            }
        `,
    },
});
